import { HubConnectionState } from '../../models';

export interface State {
  groupJoined: boolean;
  hubConnectionState: HubConnectionState | null;
  recoveryPending: boolean;
}

export const initialState: State = {
  groupJoined: false,
  hubConnectionState: null,
  recoveryPending: false,
};
